export const GET_SERVICES = 'getService'
export const SET_SERVICES = 'setService'
export const ACTIVE_SERVICE = 'activeService'
export const MARK_ACTIVE_SERVICE = 'markActiveService'